exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".zoomedIn .modal-body .myreport-table table.dataTable.session-table td { white-space: normal;}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Work/Projects/OnlineParser/web2-ui/src/app/reports/myReports/zoomView/features/features.component.css
// module id = ../../../../../src/app/reports/myReports/zoomView/features/features.component.css
// module chunks = main